export default __webpack_public_path__ + "static/media/house-big.b91b19e3.svg";